// extracted by mini-css-extract-plugin
module.exports = {"SkeletonText":"📚4-7-03ZR1m","pulsing":"📚4-7-02Hprb"};